import { type IntercomInput, type IntercomSuccess, DAY } from '@terros/common'
import { useTantalimQuery } from './query'
import { intercomKey } from './keys'
import { type GetHookResponse } from './hooks'

export function useIntercomHash(platform: string): GetHookResponse<IntercomSuccess> {
  return useTantalimQuery<IntercomInput, IntercomSuccess, IntercomSuccess>({
    url: '/app/intercom',
    queryKey: intercomKey(platform),
    input: {
      platform,
    },
    convertResponse: (data) => data,
    options: {
      gcTime: DAY,
      staleTime: DAY,
    },
  })
}

export const INTERCOM_ARTICLES = {
  canvassProWelcome: '13016107',
  aboutCanvassPro: '12844737',
  featureMilestone: '12805977',
  aboutWorkflow: '13343883',
  closerStatusOverview: '9731209',
  pitchScorecardHowTo: '12558477',
  blockCalendarAvailability: '13872175',
  areaManagementWebWhatsNew: '14833426',
  accountRollback: '17458969',
} as const
